/* global bsBreakpoints */
(() => {
  const root = document.querySelector(".hp-kiosk");
  const list = root && root.querySelector(".hp-kiosk__list");
  const itemsDefault = list && list.querySelectorAll(".hp-kiosk__list__item");
  const controls = root && root.querySelectorAll(".controls button");
  const breakpoint = function () {
    return window
      .getComputedStyle(document.body, ":before")
      .content.replace(/\"/g, "");
  };
  let counter = 0;
  const items: Element[] = [];

  const createItemList = () => {
    itemsDefault &&
      itemsDefault.forEach((item) => {
        if (window.getComputedStyle(item).display !== "none") {
          items.push(item);
        }
      });
  };

  const willActive = (index: number) => {
    items.forEach((item) => {
      if (item.classList.contains("active")) {
        item.classList.remove("active");
      }

      if (item.classList.contains("before")) {
        item.classList.remove("before");
      }

      if (item.classList.contains("after")) {
        item.classList.remove("after");
      }

      if (item.classList.contains("second-before")) {
        item.classList.remove("second-before");
      }

      if (item.classList.contains("second-after")) {
        item.classList.remove("second-after");
      }
    });
    items.length > 0 && items[index].classList.add("active");

    if (items.length === 0) {
      return;
    }

    if (index === 0) {
      items[items.length - 1].classList.add("before");
      if (breakpoint() === "xLarge" || breakpoint() === "large") {
        items[items.length - 2].classList.add("second-before");
      }
    } else {
      items[index - 1].classList.add("before");
      if (index === 1) {
        if (breakpoint() === "xLarge" || breakpoint() === "large") {
          items[items.length - 1].classList.add("second-before");
        }
      } else {
        if (breakpoint() === "xLarge" || breakpoint() === "large") {
          items[index - 2].classList.add("second-before");
        }
      }
    }

    if (index === items.length - 1) {
      items[0].classList.add("after");
      if (breakpoint() === "xLarge" || breakpoint() === "large") {
        items[1].classList.add("second-after");
      }
    } else {
      items[index + 1].classList.add("after");
      if (index === items.length - 2) {
        if (breakpoint() === "xLarge" || breakpoint() === "large") {
          items[0].classList.add("second-after");
        }
      } else {
        if (breakpoint() === "xLarge" || breakpoint() === "large") {
          items[index + 2].classList.add("second-after");
        }
      }
    }
    counter = index;
  };

  const nextItem = () => {
    if (list && list.querySelector(".active") === [...items].pop()) {
      counter = -1;
    }
    willActive(counter + 1);
  };

  const prevItem = () => {
    if (counter === 0 || counter === -1) {
      counter = items.length - 1;
      willActive(counter);
    } else {
      willActive(counter - 1);
    }
  };

  const events = () => {
    controls &&
      controls.forEach((control) => {
        control.addEventListener("click", () => {
          if (control.classList.contains("next")) {
            nextItem();
          } else {
            prevItem();
          }
        });
      });
  };

  // callback is called on intersection change
  const onIntersection = (entries: any[], opts: any) => {
    entries.forEach((entry) =>
      entry.target.classList.toggle("visible", entry.isIntersecting)
    );
  };

  const seeScroll = () => {
    let observer = new IntersectionObserver(onIntersection, {
      root: null, // default is the viewport
      threshold: 0.1, // percentage of target's visible area. Triggers "onIntersection"
    });

    root ? observer.observe(root) : null;
    // observer.unobserve(entry.target);
  };

  const init = () => {
    if (root) {
      createItemList();
      willActive(0);
      events();
      seeScroll();
    }
  };

  init();
})();
